import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { AuthService } from "./auth.service";
import { logintTypeCorpo, logintTypeInd } from "../common/constant";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const self = this;
    function goToHome() {
      if (self.authService.userData.type == logintTypeInd) {
        self.router.navigate(["/tag/ind/profile"]);
      } else {
        self.router.navigate(["/tag/corp/profile"]);
      }
    }
    const isAuth = self.authService.getIsAuth();

    if (!isAuth) {
      self.router.navigate(["/session/login"]);
      return false;
    } else {
      let role: string = next.data["role"];
      if (role) {
        role = role.toLowerCase();
      }

      // console.log('authG 1', role);
      if (role === "admin") {
        // console.log('authG A');
        if (!self.authService.isAdminU()) {
          // console.log('authG A1');
          goToHome();
          return false;
        }
      } else if (role === "ind") {
        // console.log('authG I');
        if (self.authService.userData.type !== logintTypeInd) {
          // console.log('authG I1');
          if (!self.authService.isAdminU()) {
            goToHome();
            return false;
          }
        }
      } else if (role === "corp") {
        // console.log('authG C');
        if (
          self.authService.userData.type !== logintTypeCorpo &&
          !self.authService.isAdminU()
        ) {
          // console.log('authG C1');
          if (!self.authService.isAdminU()) {
            goToHome();
            return false;
          }
        }
      } else if (role === "corpadmin") {
        if (
          self.authService.userData.type !== logintTypeCorpo ||
          !self.authService.isCorpAdminU()
        ) {
          goToHome();
          return false;
        }
      }

      // console.log('authG end');;
    }
    return isAuth;
  }
}
